// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.close-fake {
  padding-top: 40px;
  --background: transparent;
  display: flex;
  justify-content: center;
  margin-bottom: 5px;
}
.close-fake ion-icon {
  font-size: 1.4rem;
}

ion-content {
  --background: rgba(37, 33, 37, 0.84);
}

swiper-container {
  height: 85%;
}

.blocked {
  color: #b3b3b3;
}

.habilited {
  color: #ffffff;
}

.btn-download {
  position: fixed;
  bottom: 7px;
  right: 7px;
  z-index: 99;
}`, "",{"version":3,"sources":["webpack://./src/app/components/lightbox-img/lightbox-img.component.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;EACA,yBAAA;EACA,aAAA;EACA,uBAAA;EAMA,kBAAA;AAJJ;AAAI;EACI,iBAAA;AAER;;AAIA;EACI,oCAAA;AADJ;;AAIA;EACI,WAAA;AADJ;;AAIA;EACI,cAAA;AADJ;;AAIA;EACI,cAAA;AADJ;;AAIA;EACI,eAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;AADJ","sourcesContent":[".close-fake {\n    padding-top: 40px;\n    --background: transparent;\n    display: flex;\n    justify-content: center;\n\n    ion-icon {\n        font-size: 1.4rem;\n    }\n\n    margin-bottom: 5px;\n}\n\nion-content {\n    --background: rgba(37, 33, 37, 0.84);\n}\n\nswiper-container {\n    height: 85%;\n}\n\n.blocked {\n    color: #b3b3b3;\n}\n\n.habilited {\n    color: #ffffff;\n}\n\n.btn-download {\n    position: fixed;\n    bottom: 7px;\n    right: 7px;\n    z-index: 99;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
